import { useAuthContext } from 'shared/components/AuthContext'
import { SystemAdminModeDenial } from 'shared/types'
import { needsTwoFactorEnrollment, ViewerMode } from 'shared/utils'
import { isSessionExpired } from 'shared/session/utils/session'
import { getNewestAuthTime } from 'shared/session/utils/sharedAuthTime'

// Resolves to null when the mode can be entered
export const useCheckSystemAdminModeAccess = () => {
  const { auth } = useAuthContext()

  return async (): Promise<SystemAdminModeDenial | null> => {
    // 2FA may have been changed on another device since the page was opened.
    // If the reload fails, the state known so far is checked.
    await auth?.reloadUserWithTokenRefresh().catch(() => undefined)

    // The SDK signs out if the session was ended on another device
    const user = auth?.getCurrentUser()
    if (!user) return SystemAdminModeDenial.SESSION_EXPIRED

    // On failure the session guard rechecks the expiry after the switch
    const authTime = await auth?.getAuthTime().catch(() => undefined)
    if (
      authTime &&
      isSessionExpired(
        getNewestAuthTime(user.uid, authTime),
        ViewerMode.SYSTEM_ADMIN
      )
    )
      return SystemAdminModeDenial.SESSION_EXPIRED

    return needsTwoFactorEnrollment(user)
      ? SystemAdminModeDenial.TWO_FACTOR_REQUIRED
      : null
  }
}
